import { Dialog, AppBar, DialogActions, Button, WithStyles, createStyles, Theme, withStyles, DialogContent, Typography, Toolbar } from '@material-ui/core';
import { SystemButton } from './SystemsContext';
import { DeltaXMLColors } from "./styling/DeltaColors";

const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      alignItems: "left",
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    button: {
      margin: '20px'
    }
  });

export interface ErrorDialogData {
  open: boolean;
  systemButton: SystemButton;
  errorMessage: string; 
}

export interface ErrorProps extends ErrorDialogData, WithStyles<typeof styles> {
  handleClose: () => void;
}

const contentWrapper = {
  margin: '40px 16px',
}

function ErrorDialog(props: ErrorProps) {
  const { classes, open, handleClose, systemButton, errorMessage } = props;

  return (
    <div style={contentWrapper}>
      <Dialog open={open} onClose={() => { handleClose() }}>
        <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <Typography variant="h4">Error</Typography>
        </Toolbar>
        </AppBar>
        <br />
        <DialogContent>
          <p><Typography variant="body1">The <b><i>{systemButton}</i></b> operation returned an error:</Typography></p>
          <p><Typography variant="body1">{errorMessage}</Typography></p>
        </DialogContent>
        <DialogActions>
          <Button className={classes.button} variant="contained" color="primary" onClick={() => handleClose()}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
};

export default withStyles(styles)(ErrorDialog);